import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import shell7InchPortrait from 'public/images/tablet-shells/FireTabletsFeatureRotator_7inch_Portrait_FOS_Shell.png';
import {
  PreviewStateConfig,
  LayerType,
  BackgroundTransformType,
  LogoTransformType,
  GradientDirection,
} from 'src/utils/preview/types';

import {
  ALT_TEXT,
  SHIFT_FACTOR,
  FONT_FAMILY,
  TEXT_COLOR,
  MAX_LINES,
  GRADIENT_DARK,
  GRADIENT_TRANSPARENT,
  SCRIM_START,
  SCRIM_END,
} from '../constants';

export const TABLET_7INCH_PORTRAIT_FOS: PreviewStateConfig = {
  label: '7" Portrait',
  altText: ALT_TEXT,
  dimensions: { width: 600, height: 1024 },
  metadataZone: { top: 256, ctaTop: 431, safeZone: 62, leftMargin: 49 },
  layers: [
    {
      type: LayerType.BACKGROUND,
      transform: {
        type: BackgroundTransformType.CENTER_CROP,
        shiftFactor: SHIFT_FACTOR,
        x: 10,
        y: 236,
        width: 580,
        height: 260,
      },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.HORIZONTAL,
      colorStops: [
        { position: 0, color: GRADIENT_DARK },
        { position: 1, color: GRADIENT_TRANSPARENT },
      ],
      bounds: { x: 10, y: 236, width: 290, height: 260 },
    },
    {
      type: LayerType.LOGO,
      transform: {
        type: LogoTransformType.FIT_WITHIN,
        maxWidth: 247,
        maxHeight: 100,
        position: { x: 49, y: 272 },
      },
    },
    {
      type: LayerType.TEXT,
      position: {
        x: 49,
        y: 383,
      },
      fontSize: 18,
      fontFamily: FONT_FAMILY,
      color: TEXT_COLOR,
      maxWidth: 247,
      maxLines: MAX_LINES,
      lineHeight: 23,
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_START },
        { position: 1, color: SCRIM_END },
      ],
      bounds: { x: 10, y: 236, width: 580, height: 20 },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_END },
        { position: 1, color: SCRIM_START },
      ],
      bounds: { x: 10, y: 466, width: 580, height: 30 },
    },
    { type: LayerType.SHELL, src: shell7InchPortrait },
  ],
  assetRequirements: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO],
};
